import createAddMapping from './createAddMapping';
import createRemoveMappings from './createRemoveMappings';
import createGetAffected from './createGetAffected';
import createGetComponentAffected from './createGetComponentAffected';

const mappings = {};

export const addMapping = createAddMapping(mappings);
export const removeMappings = createRemoveMappings(mappings);
export const getAffected = createGetAffected(mappings);
export const getComponentAffected = createGetComponentAffected(mappings);
export {default as resolveSelectedProperty} from './resolveSelectedProperty';
export {default as resolveSelectedProperties} from './resolveSelectedProperties';
export {default as getSelectorParts} from './getSelectorParts';
export {default as isSelectableProperty} from './isSelectableProperty';
export {default as isSelector} from './isSelector';

// Unstable APIs
export {default as createUnstableResolvePropertySelectorValue} from './createUnstableResolvePropertySelectorValue';
export {default as unstableAddRenderOnPropertySelectorValueChange} from './unstableAddRenderOnPropertySelectorValueChange';
export {default as unstableRemoveRenderOnPropertySelectorValueChange} from './unstableRemoveRenderOnPropertySelectorValueChange';
